import { NetworkStatus, isInitialized } from '@cbridge-utils/network';
import { createCachedSelector, prop, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { streamSelector } from '../_selectors/stream.selector';
import { IStream } from '../stream.interface';

export const streamDetailsLoaderPropsSelector = createCachedSelector(
  [
    path(streamSelector).networkStatus(),
  ],
  (networkStatus) => {
    return {
      isLoading: networkStatus === NetworkStatus.Started,
      isInitialized: isInitialized(networkStatus),
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ streamId: IStream['streamId'] }>().streamId(),
});
